import { useMutation } from "@tanstack/react-query";
import { LeaveAPI } from "../api";

export const useCreateLeaveRequest = () => {
  return useMutation({
    mutationFn: ({
      leaveTypeID,
      startDate,
      endDate,
      durationDays,
      requestType,
      mediaID,
      reason,
    }) =>
      LeaveAPI.createLeaveRequest({
        leaveTypeID,
        startDate,
        endDate,
        durationDays,
        requestType,
        mediaID,
        reason,
      }),
    onError: (error) => {
      console.error("Create Leave Request Failed: ", error.response || error);
    },
  });
};

export const useGetAllMyEmployeeLeaveCredits = () => {
  return useMutation({
    mutationFn: () => LeaveAPI.getAllMyEmployeeLeaveCredits(),
    onError: (error) => {
      console.error(
        "Get All My Employee Leave Credits Failed: ",
        error.response || error
      );
    },
  });
};

export const useGetAllLeaveRequestsPaginated = () => {
  return useMutation({
    mutationFn: ({ page, pageSize, filters }) =>
      LeaveAPI.getAllLeaveRequestsPaginated({ page, pageSize, filters }),
    onError: (error) => {
      console.error("Get All Leave Requests Failed: ", error.response || error);
    },
  });
};

export const useGetAllLeaveTypes = () => {
  return useMutation({
    mutationFn: () => LeaveAPI.getAllLeaveTypes(),
    onError: (error) => {
      console.error("Get All Leave Types Failed: ", error.response || error);
    },
  });
};
